export const UI_SETTING_FLAGS = ['hideInbox', 'hideActions', 'hideSubmissions'] as const;

export type UiSettingsFlag = (typeof UI_SETTING_FLAGS)[number];

export type UiSettingsFormValue = {
    hideInbox: boolean;
    hideActions: boolean;
    hideSubmissions: boolean;
};

type UiSettingsCarrier = {
    uiSettings?: Partial<UiSettingsFormValue> | null;
} | null | undefined;

/** Missing or non-true flags stay visible. */
export function isUiSectionHidden(user: UiSettingsCarrier, flag: UiSettingsFlag): boolean {
    return user?.uiSettings?.[flag] === true;
}

export function uiSettingsFromUser(user: UiSettingsCarrier): UiSettingsFormValue {
    return {
        hideInbox: isUiSectionHidden(user, 'hideInbox'),
        hideActions: isUiSectionHidden(user, 'hideActions'),
        hideSubmissions: isUiSectionHidden(user, 'hideSubmissions'),
    };
}
